import { PublicClientApplication } from '@azure/msal-browser';
import {msalConfig} from './authConfig';

// Initialize MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

  // Redux MSAL Reducer
export const msalReducer = (state = {}, action) => {
    switch (action.type) {
      case 'MSAL_INSTANCE':
        return {
          ...state,
          instance: action.payload,
        };
      default:
        return state;
    }
  };